import { render, staticRenderFns } from "./DevPlan.vue?vue&type=template&id=39d5aed8"
import script from "./DevPlan.vue?vue&type=script&lang=js"
export * from "./DevPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d5aed8')) {
      api.createRecord('39d5aed8', component.options)
    } else {
      api.reload('39d5aed8', component.options)
    }
    module.hot.accept("./DevPlan.vue?vue&type=template&id=39d5aed8", function () {
      api.rerender('39d5aed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevPlan.vue"
export default component.exports